export default "__VITE_ASSET__D0Um6lwO__"